import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class SendKamDailyReportsResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                "reports": [{
                    "recipient_name": "Michael Scott",
                    "recipient_email": "michael@dundermifflin.com",
                    "blocked_customers_count": 1,
                    "at_risk_customers_count": 0,
                    "total_overdue": {"amount": 1234567.89, "currency": "ARS"},
                    "blocked_customers": [],
                    "at_risk_customers": []
                }]
            },
            errors: []
        }
    }

    reports() {
        return this.content().reports.map(report => ({
            recipientEmail: report.recipient_email,
            blockedCustomersCount: report.blocked_customers_count,
            atRiskCustomersCount: report.at_risk_customers_count,
        }));
    }

}
